import { render } from "./ManageAccessList.vue?vue&type=template&id=257e10c8"
import script from "./ManageAccessList.vue?vue&type=script&lang=js"
export * from "./ManageAccessList.vue?vue&type=script&lang=js"

import "./ManageAccessList.vue?vue&type=style&index=0&id=257e10c8&lang=css"
import "./ManageAccessList.vue?vue&type=style&index=1&id=257e10c8&scroped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__